const demo = {
  enableDemoMode: true,
  demo: {
    logoDirectsTo: 'home.leerplan',
    showReadOrder: false,
    demoVersion: '2026-2027', // changing this resets any locally stored demo-data. needs to be used when initializing a new schoolyear.
  },
};

export default demo;
